import { render, staticRenderFns } from "./InventoryItemCreate.vue?vue&type=template&id=05e84f8c&scoped=true&"
import script from "./InventoryItemCreate.vue?vue&type=script&lang=js&"
export * from "./InventoryItemCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05e84f8c",
  null
  
)

export default component.exports